import React, { Component } from 'react';

import Slideshow from './Slideshow/Slideshow';
import './App.css';
import slide1 from './Assets/images/slide1.jpg';

class App extends Component {
  slides = [
    { image: slide1, text: 'Aus Mitarbeitern werden aktive Zuhörer! Auch als digitales und anonymes Gesundheitsquiz mit Echtzeitauswertung! Themen auf Anfrage!' }
  ];

  render() {
    return (
      <div className="App">
        <div className="container text-center">
          <section className="hero">
            <h1 className="display-4">Gefährdungs&shy;beurteilung einmal anders</h1>
          </section>
        </div>

        <section className="slideshow-container">
          <div className="container">
            <Slideshow slides={this.slides} />
          </div>
        </section>

        <div className="container">
          <div className="content">
            <section>
              <h2 className="text-center">
                In Kürze Live in Ihrem Unternehmen
              </h2>

              <p className="text-center my-4">
                <span className="lead"><a href="http://www.kassandraknebel.de/">Kassandra Knebel</a></span> und <span className="lead">Astrid Somer</span> in<br /><span className="lead">„Gefährdungsbeurteilung einmal anders“</span>
              </p>

              <p>
                Ein „Forumtheater“ rundum der Gefährdungsbeurteilung psychischer Belastungen. Gezeigt werden Szenen aus dem Bereich der „Arbeitsorganisation“ und viele weitere, siehe BAuA und GDA.
              </p>

              <h5>Unsere Ziele</h5>
              <ul>
                <li>Visualisierung von Vor- und Nachteilen der Maßnahmen</li>
                <li>Unterstützung in der Vorbeugung von Unfällen und arbeitsbedingten Gesundheitsgefahren</li>
                <li>Interaktive Bearbeitung und Optimierung von Maßnahmen</li>
              </ul>

              <h5>Ihr Nutzen</h5>
              <ul>
                <li>Empfohlene Maßnahmen werden humorvoll aufgearbeitet (größerer Lerneffekt!)</li>
                <li>Sensibilisierung Ihrer Mitarbeiter/innen im Umgang mit dem Thema</li>
                <li>Einfache Umsetzung der Maßnahmen in die Praxis</li>
              </ul>

              <h5>Mitwirkende am Forumtheater</h5>
              <ul>
                <li>Eine „Maßnahmenentwicklungsgruppe“</li>
                <li>Ihre Mitarbeiter</li>
                <li>Die Schauspielerin Kassandra Knebel</li>
                <li>Die Moderatorin Astrid Somer</li>
              </ul>

              <h5>Referenz</h5>
              <ul>
                <li>
                  <a href="https://www.bgrci.de/">Berufsgenossenschaft Rohstoffe und chemische Industrie, Präventionszentrum Berlin</a>
                  <br />
                  Herr Michael Schwabe
                </li>
              </ul>
            </section>
          </div> {/* .content */}
        </div> {/* .container */}

        <div className="footer">
          <div className="content text-center">
            Ausführliche Informationen unter <a href="mailto:info@astridsomer.com">info@astridsomer.com</a> oder
            telefonisch unter <a href="tel:+4946199229977">0461&nbsp;99&nbsp;22&nbsp;99&nbsp;77</a> oder <a href="tel:+4915205798174">0152&nbsp;05&nbsp;798&nbsp;174</a>.

            <div className="mt-3">
              <a href="impressum.html" className="mr-3">Impressum</a>
              <a href="datenschutz.html">Datenschutzerklärung</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js